import React, { useState, useEffect, useContext } from "react";
import Table from "../../../components/Table";
// import { TABLEDATA, FEATURETABLE, CUSTOMERTABLE } from "../../../utils/data";
import GeneralInfo from "../../../components/GeneralInfo";
import { makeApiCall } from "../../../config";
import { successToaster } from "../../../utils/toaster";
import { FeatureTableColumns, CustomerTableColumns } from "./TableColumns";
import AuthContext from "../../../context/AuthContext";
import Loader from "../../../components/Loader";
import Error from "../../../components/Error";
import CustomerListPage from "./CustomerListPage";
import FeedPage from "./FeedPage";

export default function Customers() {
  const [featureTable, setFeatureTable] = useState([])
  const {userInfo, enableToaster, getUserInfo} = useContext(AuthContext);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedUrl, setSelectedUrl] = useState(null);
  const [enableLoader, setEnableLoader] = useState(false);
  const [activeUser, setActiveUser] = useState({});
  
  async function getUserAnalytics(userParam) {
    try {
      const res = await makeApiCall("/api/v1/tracker/user/analytics", "get", null, {hostname: userParam.defaultURL, userId: userParam._id});
      setFeatureTable(res.data);
      enableToaster && successToaster(res.message);
      setEnableLoader(false)
      return;
    } catch (error) {
      // ErrorToaster("something went wrong");
      setEnableLoader(false)
      console.log("error occurred in getUserAnalytics", error);
      return;
    }
  }
  useEffect(() => {
    setEnableLoader(true);
    (async() =>{
      const userData = await getUserInfo();
        await getUserAnalytics(userData);
    })()
   
  }, []);
  const handleUserClick = async(userId, activeUsers) => {
    setEnableLoader(true)
    try {
      const res = await makeApiCall("/api/v1/tracker/user/analytics", "post", {userId});
      setSelectedUserId(res.data);
      enableToaster && successToaster(res.message);
      setEnableLoader(false);
      setActiveUser(activeUsers);
      return;
    } catch (error) {
      // ErrorToaster("something went wrong");
      setEnableLoader(false)
      console.log("error occurred in getUserAnalytics", error);
      return;
    }
  };

  const handleFeatureUserClick = (userId) => {
    setSelectedUrl(userId.original.userInfo);
  };

  return (
    <>
    {/* feature Table */}
    {/* {!selectedUrl && featureTable && (<div className=" mt-5 cursor-pointer">
    <Table tableData={featureTable} columns={FeatureTableColumns} onUserClick={handleFeatureUserClick} title={"User Analytics Table"}/>
    </div>)} */}
    {/* customer Table */}
    {(enableLoader || !userInfo) && <Loader/>}
    {!enableLoader && featureTable.length == 0  && <Error/>}
      {featureTable.length !== 0 && !selectedUserId && (<div className=" mt-5 cursor-pointer">  
        <CustomerListPage usersList={featureTable} onUserClick={handleUserClick}/>
        {/* <Table tableData={featureTable} columns={CustomerTableColumns} onUserClick={handleUserClick} title={"Customer Table"}/> */}
      </div>)}
      {selectedUserId && (<div className=" mt-5">
        <FeedPage userData={activeUser} feedData={selectedUserId} handleBackBtn={setSelectedUserId}/>
        {/* <GeneralInfo user={selectedUserId} handleBackBtn={setSelectedUserId}/> */}
      </div>)}
    </>
  );
}
